import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { branch, renderComponent } from 'recompose';
import LoadingPage from "./index";
var loadingFunction = function loadingFunction(_ref) {
  var loading = _ref.loading;
  return loading;
};

/**
 * Usage
 * -----
 *
 * Call the function to get an enhancer to wrap a loading component.
 * All parameters are optional.
 * Component - A react component to be rendered as the loading state
 * isLoading - A function that receives an object the component props and
 * returns true if the loading component should be rendered instead of the
 * actual component.
 */
var displayLoadingState = function displayLoadingState() {
  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LoadingPage;
  var isLoading = arguments.length > 1 ? arguments[1] : undefined;
  var func = loadingFunction;
  if (isLoading) {
    if (typeof isLoading !== 'function') {
      console.error("displayLoadingState(): isLoading parameter has invalid type: ".concat(_typeof(isLoading), ". Expected 'function'"));
    } else {
      func = isLoading;
    }
  }
  return branch(func, renderComponent(Component));
};
export default displayLoadingState;